import { GTMEvent } from '../GTM'

export const pushPromotionView = (data: Record<string, unknown>): GTMEvent => {
    const { items } = data
    if (!Array.isArray(items)) {
        console.info('Invalid GTM promotion view data')
        return { event: '' }
    }

    return {
        event: 'promotionView',
        ecommerce: {
            promoView: {
                promotions: [...items]
            }
        },
        _clear: true
    }
}
